/*
 * Alma group footer loader (Alma Content Router).
 *
 * ACCEPTED RISK — see AJOMARK-22839.
 * The footer HTML is fetched from `almacrcommoncontent.net` and its inline
 * <script> (the `@almamedia/footer` web component) is injected and executed
 * below. The source is FIRST-PARTY: Alma Media is our parent company and owns
 * both this site and the content router, so this is trusted internal content,
 * not an untrusted third-party/supply-chain dependency. The flagged "DOM-XSS"
 * is therefore low real-world severity.
 *
 * This injection is intentional and currently required: the footer
 * (`<almamedia-footer>` web component) is delivered ONLY as an inline minified
 * bundle in that response — the footer markup and link data live inside the
 * script, so removing/sanitizing it leaves a blank footer.
 *
 */
const almaFooter = {
    transferComplete(slotId) {
        let targetElement;
        let scripts;

        targetElement = document.createElement('div');
        targetElement.innerHTML = this.responseText;
        targetElement.setAttribute('id', `alma-content-router-target-${slotId}`);
        scripts = Array.prototype.slice.call(targetElement.getElementsByTagName('script'));
        document.body.appendChild(targetElement);
        scripts.forEach(function (script) {
            const scriptNode = document.createElement('script');
            scriptNode.text = script.text;
            document.body.appendChild(scriptNode);
            document.body.removeChild(scriptNode);
        });
    },
    transferFailed() {
        this.log('Transfer failed for loading content from Alma Content Router');
    },
    transferCanceled() {
        this.log('Transfer cancelled for loading content from Alma Content Router');
    },
    log(...args) {
        if ('console' in window && typeof window.console.log === 'function') {
            if (typeof window.console.error === 'function' && args[1] instanceof Error) {
                window.console.error(...args);
            } else {
                window.console.log(...args);
            }
        }
    },
    almaContentRouterRequest(slotId) {
        try {
            let url;
            let request;

            url = `https://almacrcommoncontent.net/${slotId}`;
            request = new XMLHttpRequest();
            request.addEventListener('load', this.transferComplete);
            request.addEventListener('error', this.transferFailed.bind(this));
            request.addEventListener('abort', this.transferCanceled.bind(this));
            request.open('GET', url);
            request.send();
        } catch (e) {
            this.log('Error loading content from Alma Content Router', e);
        }
    },
};

$(function () {
    almaFooter.almaContentRouterRequest('5577dbe2b922930e0c000022');
});
